const DATABASE_ROOT_OWNED_PROPS = new Set([
  'activeViewId',
  'allowDelete',
  'canvasPresentation',
  'cells',
  'columns',
  'comments',
  'databaseShardManifest',
  'managedBy',
  'schemaLocked',
  'systemManaged',
  'title',
  'views',
]);

const DATABASE_HOST_OWNED_PROPS = new Set([
  'docScoped',
  'fileIndexLastXYWH',
  'index',
  'lockedBySelf',
  'visible',
  'xywh',
]);

function shouldMaterializeDefaultProp(input: {
  docId?: string;
  flavour: string;
  key: string;
  props: Record<string, unknown>;
}) {
  if (input.flavour !== 'affine:database') {
    return true;
  }

  const rootDocId = input.props.databaseRootDocId;
  if (typeof rootDocId !== 'string' || !rootDocId) {
    return true;
  }

  const isStorageRoot = input.docId === rootDocId;
  if (isStorageRoot) {
    return !DATABASE_HOST_OWNED_PROPS.has(input.key);
  }

  return (
    !DATABASE_ROOT_OWNED_PROPS.has(input.key) &&
    !DATABASE_HOST_OWNED_PROPS.has(input.key)
  );
}

export function shouldHydrateMissingDefaultProp(input: {
  docId?: string;
  flavour: string;
  key: string;
  props: Record<string, unknown>;
}) {
  // Sharded database host docs own xywh. Old local-first imports could persist a
  // canvas host reference without xywh, which must still hydrate before GFX
  // bounds/minimap code reads the model.
  if (
    input.flavour === 'affine:database' &&
    input.key === 'xywh' &&
    typeof input.props.databaseRootDocId === 'string' &&
    input.props.databaseRootDocId &&
    input.docId !== input.props.databaseRootDocId
  ) {
    return true;
  }

  return shouldMaterializeDefaultProp(input);
}

export function shouldPersistHydratedDefaultProp(input: {
  docId?: string;
  flavour: string;
  key: string;
  props: Record<string, unknown>;
}) {
  if (!shouldMaterializeDefaultProp(input)) {
    return false;
  }

  // Geometry defaults are render-time fallbacks only. Persisting a fallback
  // during hydration can overwrite server-created canvas placement from a
  // stale or partially-loaded local document.
  return input.key !== 'xywh';
}
